export default __webpack_public_path__ + "static/media/Band CT Too Big.a7e268c5.png";